import { render } from "./ResidentList.vue?vue&type=template&id=cdbedf60&ts=true"
import script from "./ResidentList.vue?vue&type=script&lang=ts"
export * from "./ResidentList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__